<template>
    <!--component temporal! sha de generalitzar!-->
    <div>
      <div v-if="(!mutableList || mutableList.length == 0) && !show">
          Añadir referencia
          <v-btn @click="show=!show; add_ref()"
                  color="primary"
                  icon>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
      </div>
      <div v-else-if="!show">
        {{mutableList.length}} referencias 
        <v-btn @click="show=true"
              color="primary"
              icon
              >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </div>
      <div v-else>
        {{mutableList.length}} referencias 
        <v-btn @click="show=false;clear_ref_list()"
        color="primary"
        icon
        >
          <v-icon>mdi-arrow-up-thick</v-icon>
        </v-btn>
      </div>
      <div key="mutableList.length" v-if="show">
          <v-row no-gutters>
            <v-col cols="10" class="text-center table-head primary--text">
              Referencias
            </v-col>
            <v-col cols="2">
              <v-btn 
                @click="add_ref()"
                class="ma-0 pa-4"
                color="primary"
                icon>
                <v-icon >mdi-plus</v-icon>
              </v-btn>
            </v-col>    
          </v-row>
          <v-row v-for="(ref,i) in mutableList" :key="i" no-gutters>
            <v-col cols="10" class="table-row ma-0 pa-0">
                <doc-text-field 
                v-model="mutableList[i]"
                :hide-details="true"
                autocomplete="off"
                @input="update"
                ></doc-text-field>
            </v-col>
            <v-col cols="2" class="ma-0 pa-0">
              <v-btn @click="remove_ref(i)"
              color="primary"
              icon>
                <v-icon >mdi-delete</v-icon>
              </v-btn>
            </v-col>   
          </v-row>
      </div>
    </div>
</template>

<script>
import { createHelpers,mapFields } from 'vuex-map-fields';
import {mapFieldsMetadata,vuexPrefix} from "../store/vuex_utils"
import { mapActions, mapGetters } from "vuex"
import DocTextField from './DocTextField.vue'


export default {
  name: 'DetailReferenceSimple',
  components:{
      DocTextField,
  },
  props:{ 
    ref_list:{
      type:Array,
      required:true,   
    }
  },
  data(){
    return{
      show:false,
      mutableList: [],
    }
  },
  created(){
    this.mutableList = this.ref_list
    this.clear_ref_list()
  },
  computed:{
    // ...mapFields('cru',vuexPrefix('cru_',['ref_list'],'screenValues.supplierScreenValues.')),
  },
  methods:{
    update(){
        this.$emit('update', this.mutableList)
      },
      add_ref(){
        this.mutableList.push('')
        this.update()
      },
      remove_ref(i){
        this.mutableList.splice(i,1)
        this.update()
      },
      clear_ref_list(){
        for(let i = 0; i< this.ref_list.length;i++){
          if(this.mutableList[i] == ''){
            this.mutableList.splice(i,1)
            i--
          }
        }
        this.update()
      } 
  }
}
</script>
<style scoped>
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:#663399;
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-color:#663399;
        border-width: thin;
        align-content: center;
    }

</style>
<style lang="scss" scoped>
  .primary-bckground {
    background-color: #663399;
  }
  .primary-border {
    border-color: #663399 !important;
  }
</style>